function copyToClipboard (string: string) {
  window.navigator.clipboard.writeText(string)
}

export default copyToClipboard
